import React from "react";
import { Layout, Button, Row, Col, Form, Input } from 'antd';
import autoBind from 'react-autobind';
import { withGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { IDMGlobals } from "@ikonintegration/idmclient";
//
import Logo from '../commonComponents/Logo';
import CustomComponent from "@/components/CustomComponent";
import CommonLoadingView from "../commonComponents/CommonLoadingView";
import Utils from '@/components/Utils';
import CommonBoxLinks from '../commonComponents/CommonBoxLinks';
//
import config from "@/config/config";
import Globals from "@/config/Globals";
//
import "@/stylesheets/CommonReset.less";
//
class CommonResetPasswordRequestView extends CustomComponent {
  constructor(props) {
    super(props);
    autoBind(this);
    const paramValue = this.props.app.urlManager.getPathParam(Globals.URL_Path_ID_Placeholder, this);
    this.state = { data: { username: (paramValue ? paramValue : '') }, isLoading: false };
  }

  componentDidMount() {
    super.componentDidMount();
    Utils.showGoogleRecaptchaBagde();
    document.title = `Forgot Password - ${this.props.app.themeManager.theme.applicationName}`;
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    Utils.hideGoogleRecaptchaBagde();
  }

  //Actions
	async handleForgotPassword(){
    const formData = await this.form.validateFields();
    if (formData) {
      this._forgotPassword(formData.email);
    }
  }
  
  //UI
  render() {
    const isLoading = this.state.isLoading || this.props.app.onGoingBehaviour.isAuthenticating;
    const editMode = true;
    return (
      <Layout.Content className='pageContentFullScreen'>
        <CommonLoadingView isLoading={isLoading} isFixed={true} />
        <Layout.Content className='resetContainer'>
          <Row type="flex" justify="center" align="middle">
          <Col className='resetBoxContainer' align='middle' justify="center">
            <div className='resetBox'>
              <Row type="flex" justify="center" align="middle">
                  <Col> <Logo app={this.props.app}/> </Col>
              </Row>
              <Row type="flex" justify="center" align="middle">
                <Col>
                    <h5 className="resetBoxTitle">Reset your {this.props.app.themeManager.theme.applicationName}<br></br> account password</h5>
                </Col>
              </Row>
              <Form layout="vertical" {...Utils.propagateRef(this, 'form')} className='resetForm'>
                <Row type="flex" justify="center" align="middle">
                  <Col span={22}>
                    <Form.Item
                      initialValue={this.state.data.username}
                      name="email"
                      label="Email"
                      rules={[
                        { required: true, message: 'This field is required' },
                        { min: 10, max: 255, message: 'Email must be between 10 and 255 characters' },
                        { type: 'email', message: 'Invalid email format' }
                      ]}
                    >
                      <Input disabled={!editMode} />
                    </Form.Item>
                  </Col>
                </Row>
                <Button block onClick={this.handleForgotPassword} className='resetButton' type="primary" htmlType="submit"> Reset </Button>
              </Form>
            </div>
          </Col>
        </Row>
          <CommonBoxLinks width={500} app={this.props.app}/>
        </Layout.Content>
      </Layout.Content>
    );
  }

  async _forgotPassword(email) {
    this.startLoading();
    //
    //Try to get captcha
    let token = null;
    try { token = await this.props.googleReCaptchaProps.executeRecaptcha('registration'); }
    catch (e) { console.error(e); }
    if (!token) {
      this.props.app.alertController.showErrorAlert('Error!', 'Invalid captcha authentication. This might be a problem with your page, try reloading it first. If this issue persists, please, contact the support!');
      this.stopLoading();
      return;
    }
    //
    const resetResp = await this.props.app.idm.api.password.reset(email, token);
    if (resetResp.statusCode == 200) {
      if (resetResp.body.reregistered) {
        this.props.app.urlManager.preAuthorizationRedirect(config.ApplicationRoutes.login, { [IDMGlobals.URLQueryParam_UserEmail]: email });
        this.props.app.alertController.showSuccessAlert("", "Password reset succeed, check you email for a new password!");
      } else {
        this.props.app.alertController.showSuccessAlert("", "Password reset succeed, check you email for a reset code!");
        this.props.app.urlManager.preAuthorizationRedirect(config.ApplicationRoutes.resetPasswordConfirmation, null, email);
      }
    } else {
      this.props.app.alertController.showAPIErrorAlert(null, resetResp);
      this.stopLoading();
    }
  }
}

const CommonResetPasswordRequestViewRecaptcha = withGoogleReCaptcha(CommonResetPasswordRequestView);
export default class CommonResetPasswordRequestViewHOC extends React.Component {
    render() {
      return (
        <CommonResetPasswordRequestViewRecaptcha {...this.props}/>
      );
    }
}
